module.exports = __webpack_public_path__ + "img/logo-boss.24c20bfa.jpg";